import { useState } from 'react';
import { t } from '../../helpers/i18n';
import BreadCatalogTab from './BreadCatalog/BreadCatalogTab';
import FillingsTab from './FillingsTab';
import './Settings.css';
import './Stitch.css';

export default function Settings({ userRoles = [] }) {
  const [activeTab, setActiveTab] = useState('bread-catalog');

  return (
    <div className="basicContainer settings-container">
      <div className="settings-wrapper">
        <div className="settings-content">
          <h1>{t({ en: 'Store Settings', es: 'Configuración de Tienda' })}</h1>

          <div className="settings-tabs">
            <button
              className={`settings-tab ${activeTab === 'bread-catalog' ? 'settings-tab--active' : ''}`}
              onClick={() => setActiveTab('bread-catalog')}
            >
              {t({ en: 'Bread Catalog', es: 'Catálogo de Pan' })}
            </button>
            {/* Fillings tab hidden for now — re-enable when needed */}
          </div>

          {activeTab === 'bread-catalog' ? (
            <BreadCatalogTab />
          ) : null}
        </div>
      </div>
    </div>
  );
}
